import styled from 'styled-components';

import {
  Text,
  Flex,
} from 'web-styled';

export const Search = styled(Flex).attrs({
  flex: '0 0 68px',
  align: 'center',
})`
  width: 100%;
  padding: 0 15px;

  & > div {
    width: 100%;
  }
`;

export const Header = styled(Flex).attrs({
  align: 'center',
  spacing: 10,
  justify: 'space-between',
})`
  width: 100%;
  padding: 0 15px 4px;
  border-bottom: 1px solid #e9eaea;
`;

export const Item = styled(Flex).attrs({
  width: '100%',
  shrink: 0,
})`
  border-bottom: 1px solid #e9eaea;

  .actions {
    visibility: hidden;
  }

  &:hover {
    background: #fbfbfb;

    .actions {
      visibility: visible;
    }
  }
`;

export const HeaderName = styled(Text)`
  font-size: 14px;
  color: #c4c4c4;
  text-align: left;
`;

export const TabLink = styled.button`
  color: ${props => (props.active ? props.theme.colors.primary : '#9ea0a1')};
  font-size: 14px;
  font-weight: 400;
  padding: 10px 10px;
  border: 0;
  border-radius: 0;
  outline: none;
  box-shadow: 0;
  border-bottom: 2px solid ${props => (props.active ? props.theme.colors.primary : 'transparent')};
  background-color: transparent;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.colors.primary};
    background-color: transparent;
  }
`;
